import * as React from 'react';
import Button from '../../common/Button/Button';
import type { ModalContext } from '../Modal/types';
import cn from '~modules/cn';

import UpgradeIcon from '../../../assets/icons/v2design/basics/upgrade.svg';

import './upgrade-modal.scss';

export type UpgradeModalProps = {
    Modal?: React.ElementType;
    title: string;
    description?: string;
    children?: React.ReactNode;
    className?: string;
    onClose?: () => void;
    buttonTitle?: string;
    onButtonClick?: () => void;
    setRef?: React.MutableRefObject<ModalContext | null>;
    modalProps?: $TSFixMe;
    buttonPosition?: 'beforeChildren' | 'afterChildren';
};

const UpgradeButton = ({ buttonTitle, onButtonClick, setRef }: Pick<UpgradeModalProps, 'buttonTitle' | 'setRef' | 'onButtonClick'>) => (
    <Button
        icon={<UpgradeIcon />}
        buttonType="upgrade"
        className="upgrade-modal__upgrade-button"
        type="button"
        onClick={() => {
            setRef?.current?.close();
            onButtonClick?.();
        }}
    >
        {buttonTitle}
    </Button>
);

export const UpgradeModal = (props: UpgradeModalProps): JSX.Element => {
    const { Modal = 'div', buttonTitle = 'Contact us', buttonPosition = 'afterChildren' } = props;
    return (
        <Modal
            className={cn('upgrade-modal', props.className)}
            fullScreen
            useBaseModal
            setRef={props.setRef}
            onClose={props.onClose}
            showCloseButton
            {...props.modalProps}
        >
            <div className="upgrade-modal__container">
                <h3 className="upgrade-modal__header">{props.title}</h3>
                {props.description && <p className="upgrade-modal__description">{props.description}</p>}
                {buttonPosition === 'beforeChildren' && <UpgradeButton buttonTitle={buttonTitle} setRef={props.setRef} onButtonClick={props.onButtonClick} />}
                {props.children && <div className="upgrade-modal__contents">{props.children}</div>}
                {buttonPosition === 'afterChildren' && <UpgradeButton buttonTitle={buttonTitle} setRef={props.setRef} onButtonClick={props.onButtonClick} />}
            </div>
        </Modal>
    );
};

export default UpgradeModal;
